import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'
import PlaceOrder from '../../../pages/orders/place-order/place-order'

export const Route = createFileRoute('/$clientid/_app/place-order')({
    component: PlaceOrder,
    validateSearch: (search) =>
        z
            .object({
                source: z.string().trim().optional(),
            })
            .catchall(z.string())
            .optional()
            .parse(search),
})
